import CardMedia from '@mui/material/CardMedia';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {useEffect, useState} from 'react';
import {getEventDay} from '../api/eventDayApi';
import type {EventDay} from '../entities/EventDay';
import {getCookie, setCookie} from '../util/cookieUtils';
import {isNotFound} from '../util/httpErrors';
import YouTubeVideo from './YouTubeVideo';

const COOKIE = 'last_notification_day';

/** Shows today's greeting (picture and/or video) once per day. */
export default function NotificationDialog() {
  const [today, setToday] = useState<EventDay>();
  const [lastNotificationDayId, setLastNotificationDayId] = useState(-1);

  useEffect(() => {
    getEventDay('today')
      .then(day => {
        setLastNotificationDayId(parseInt(getCookie(COOKIE) || '-1', 10));
        setToday(day);
      })
      .catch((error: unknown) => {
        if (!isNotFound(error)) {
          throw error;
        }
      });
  }, []);

  if (!today?.greeting) {
    return null;
  }
  const greeting = today.greeting;
  const open = lastNotificationDayId !== today.id;
  return (
    <Dialog
      open={open}
      keepMounted={true}
      maxWidth="lg"
      fullWidth={!!greeting.youtubeUrl}
      onClose={() => {
        setCookie(COOKIE, today.id.toString());
        setLastNotificationDayId(today.id);
      }}
    >
      {greeting.pictureUrl && <CardMedia component="img" image={greeting.pictureUrl}/>}
      {open && greeting.youtubeUrl && (
        <DialogContent sx={{padding: 0}}>
          <YouTubeVideo url={greeting.youtubeUrl}/>
        </DialogContent>
      )}
    </Dialog>
  );
}
